import { TOGGLE_BOTTOM_NAVIGATION_DRAWER_ROUTE } from "../../../../../constants/env";

export function isDrawerTogglerPath(path?: string): boolean {
  if (!path) {
    return false;
  }

  return path === TOGGLE_BOTTOM_NAVIGATION_DRAWER_ROUTE;
}
